<div class="pl-video-progress-bar">
  <mat-slider class="!tw-w-full" [min]="min" [max]="max" [step]="step">
    <input matSliderThumb [value]="value" (valueChange)="onValueChange($event)" />
  </mat-slider>
</div>
